import { render, staticRenderFns } from "./votingList.vue?vue&type=template&id=ca5a3ba8&scoped=true&"
import script from "./votingList.vue?vue&type=script&lang=js&"
export * from "./votingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5a3ba8",
  null
  
)

export default component.exports